module.exports = __webpack_public_path__ + "img/iconAvailableBike.1fb08c75.png";